import { OrgMembersTab } from "./OrgMembersTab";
import { NON_CLIENT_PERMISSION_WHITELIST } from "../../lib/api/betterAuth";

export function NonClientTab() {
  return (
    <OrgMembersTab
      kind="non_client"
      title="Non Client"
      subtitle={(orgName) =>
        `Manage Better Auth permissions for non-client users under ${orgName}`
      }
      allowedPermissionTypes={NON_CLIENT_PERMISSION_WHITELIST}
      showCustomerColumns={false}
      emptyMessage="No non-client members found."
    />
  );
}

export default NonClientTab;
